(function () {
  'use strict';

  var CONTEXT_LABELS = {
    contact: 'Contact',
    faq: 'FAQ overflow',
    review: 'Avis client',
    newsletter: 'Newsletter'
  };

  function getContextLabel(form) {
    var ctx = form.getAttribute('data-consent-context') || 'contact';
    return CONTEXT_LABELS[ctx] || ctx;
  }

  function buildConsentPrefix(form, marketingChecked) {
    var marketing = marketingChecked ? 'OUI' : 'NON';
    return (
      '--- Consentements (' +
      getContextLabel(form) +
      ') ---\n' +
      'Traitement des données : OUI\n' +
      'Offres commerciales par e-mail : ' +
      marketing +
      '\n' +
      'SMS : non proposé actuellement\n' +
      '--- Message ---\n'
    );
  }

  function initConsentForm(form) {
    if (!form || form.dataset.caniculeConsentBound === 'true') return;
    form.dataset.caniculeConsentBound = 'true';

    var processingConsent = form.querySelector('[data-consent-processing]');
    var marketingConsent = form.querySelector('[data-consent-marketing]');
    var submitBtn = form.querySelector('[type="submit"]');
    var bodyField = form.querySelector('[name="contact[body]"]');
    var acceptsMarketing = form.querySelector('.canicule-newsletter-form__accepts-marketing');

    function syncSubmitState() {
      var ok = processingConsent && processingConsent.checked;
      if (submitBtn) submitBtn.disabled = !ok;
      if (acceptsMarketing) {
        acceptsMarketing.disabled = !ok;
      }
    }

    if (processingConsent) {
      processingConsent.addEventListener('change', syncSubmitState);
      syncSubmitState();
    }

    form.addEventListener('submit', function (event) {
      if (!processingConsent || !processingConsent.checked) {
        event.preventDefault();
        return;
      }

      if (bodyField && !bodyField.dataset.consentPrefixed) {
        var marketingChecked = marketingConsent && marketingConsent.checked;
        bodyField.value = buildConsentPrefix(form, marketingChecked) + bodyField.value.trim();
        bodyField.dataset.consentPrefixed = 'true';
      }
    });
  }

  function boot(scope) {
    (scope || document)
      .querySelectorAll('[data-canicule-consent-form]')
      .forEach(initConsentForm);
  }

  document.addEventListener('DOMContentLoaded', function () {
    boot(document);
  });
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
